// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Register.responsive.css
   Responsive Stylesheet for MedGen Account Registration
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .medgen-register-screen {
    width: 100%;
    max-width: 100vw;
    padding: 24px 20px !important;
    min-height: 100dvh !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    overflow-x: hidden !important;
  }

  .medgen-register-shell {
    grid-template-columns: 1fr !important;
    max-width: 540px !important;
    margin: 0 auto !important;
    border-radius: 24px !important;
  }

  .medgen-register-intel {
    padding: 24px !important;
  }

  .medgen-register-card-wrap {
    padding: 24px !important;
  }

  .medgen-trust-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .medgen-register-screen {
    padding: 14px 10px !important;
    align-items: flex-start !important;
  }

  .medgen-register-shell {
    grid-template-columns: 1fr !important;
    max-width: 100% !important;
    border-radius: 18px !important;
    box-shadow: 0 10px 30px rgba(3, 6, 12, 0.25) !important;
  }

  /* Compact branding header on mobile */
  .medgen-register-intel {
    padding: 16px 14px !important;
  }

  .medgen-intel-top {
    gap: 10px !important;
  }

  .medgen-logo-mark {
    width: 40px !important;
    height: 40px !important;
    flex-basis: 40px !important;
  }

  .medgen-logo-mark img {
    width: 30px !important;
    height: 30px !important;
  }

  .medgen-intel-top h1 {
    font-size: 20px !important;
    line-height: 1.15 !important;
  }

  .medgen-intel-copy {
    font-size: 12px !important;
    line-height: 1.45 !important;
    margin: 8px 0 12px !important;
  }

  .medgen-trust-grid {
    display: none !important;
  }

  /* Form Card */
  .medgen-register-card-wrap {
    padding: 14px !important;
  }

  .medgen-register-card {
    padding: 18px 14px !important;
    border-radius: 16px !important;
  }

  .medgen-form-logo {
    display: none !important;
  }

  .medgen-form-heading h2 {
    font-size: 22px !important;
  }

  .medgen-form-heading p {
    font-size: 12.5px !important;
  }

  .medgen-role-row {
    gap: 6px !important;
  }

  .medgen-role-pill {
    min-height: 36px !important;
    padding: 6px 10px !important;
    font-size: 11.5px !important;
  }

  .medgen-input-shell {
    min-height: 44px !important;
    border-radius: 12px !important;
    padding: 0 12px !important;
  }

  .medgen-input-shell input,
  .medgen-input-shell select {
    font-size: 14px !important;
  }

  .medgen-register-btn {
    min-height: 44px !important;
    font-size: 14px !important;
    border-radius: 12px !important;
  }

  .medgen-auth-footer {
    flex-direction: column !important;
    gap: 6px !important;
    margin-top: 14px !important;
    text-align: center !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Register.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;EAC/B;;EAEA;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;EACtB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,6BAA6B;IAC7B,kCAAkC;EACpC;;EAEA;IACE,qCAAqC;IACrC,0BAA0B;IAC1B,8BAA8B;IAC9B,uDAAuD;EACzD;;EAEA,sCAAsC;EACtC;IACE,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,cAAc;EACd;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;EAC/B;AACF","sourcesContent":["/* ==========================================================================\n   Register.responsive.css\n   Responsive Stylesheet for MedGen Account Registration\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .medgen-register-screen {\n    width: 100%;\n    max-width: 100vw;\n    padding: 24px 20px !important;\n    min-height: 100dvh !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    overflow-x: hidden !important;\n  }\n\n  .medgen-register-shell {\n    grid-template-columns: 1fr !important;\n    max-width: 540px !important;\n    margin: 0 auto !important;\n    border-radius: 24px !important;\n  }\n\n  .medgen-register-intel {\n    padding: 24px !important;\n  }\n\n  .medgen-register-card-wrap {\n    padding: 24px !important;\n  }\n\n  .medgen-trust-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 10px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .medgen-register-screen {\n    padding: 14px 10px !important;\n    align-items: flex-start !important;\n  }\n\n  .medgen-register-shell {\n    grid-template-columns: 1fr !important;\n    max-width: 100% !important;\n    border-radius: 18px !important;\n    box-shadow: 0 10px 30px rgba(3, 6, 12, 0.25) !important;\n  }\n\n  /* Compact branding header on mobile */\n  .medgen-register-intel {\n    padding: 16px 14px !important;\n  }\n\n  .medgen-intel-top {\n    gap: 10px !important;\n  }\n\n  .medgen-logo-mark {\n    width: 40px !important;\n    height: 40px !important;\n    flex-basis: 40px !important;\n  }\n\n  .medgen-logo-mark img {\n    width: 30px !important;\n    height: 30px !important;\n  }\n\n  .medgen-intel-top h1 {\n    font-size: 20px !important;\n    line-height: 1.15 !important;\n  }\n\n  .medgen-intel-copy {\n    font-size: 12px !important;\n    line-height: 1.45 !important;\n    margin: 8px 0 12px !important;\n  }\n\n  .medgen-trust-grid {\n    display: none !important;\n  }\n\n  /* Form Card */\n  .medgen-register-card-wrap {\n    padding: 14px !important;\n  }\n\n  .medgen-register-card {\n    padding: 18px 14px !important;\n    border-radius: 16px !important;\n  }\n\n  .medgen-form-logo {\n    display: none !important;\n  }\n\n  .medgen-form-heading h2 {\n    font-size: 22px !important;\n  }\n\n  .medgen-form-heading p {\n    font-size: 12.5px !important;\n  }\n\n  .medgen-role-row {\n    gap: 6px !important;\n  }\n\n  .medgen-role-pill {\n    min-height: 36px !important;\n    padding: 6px 10px !important;\n    font-size: 11.5px !important;\n  }\n\n  .medgen-input-shell {\n    min-height: 44px !important;\n    border-radius: 12px !important;\n    padding: 0 12px !important;\n  }\n\n  .medgen-input-shell input,\n  .medgen-input-shell select {\n    font-size: 14px !important;\n  }\n\n  .medgen-register-btn {\n    min-height: 44px !important;\n    font-size: 14px !important;\n    border-radius: 12px !important;\n  }\n\n  .medgen-auth-footer {\n    flex-direction: column !important;\n    gap: 6px !important;\n    margin-top: 14px !important;\n    text-align: center !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
